import Cookies from 'universal-cookie';
const cookie = new Cookies();
export default cookie;


// WEBPACK FOOTER //
// ./src/utilities/cookie.js